import { AtlenzCountersResponse, getAtlenzCatalogResourcesCount } from 'src/services/http/search';
import { ResourceCount, TaxonomyCount } from 'src/pages/CatalogPage/utils/taxonomy';

enum AtlenzFilterType {
  duration = 'durationCounters',
  type = 'typeCounters',
  learningLevel = 'levelCounters',
  product = 'productCounters',
  productRole = 'userRolesCounters',
  deployment = 'deploymentCounters',
}

const AtlenzTaxonomyMap = {
  duration: {
    more_than_2_hours: 'More than 2 hours',
    less_than_30_min: 'Less than 30 min',
    '30_min_to_1_hour': '30 min to 1 hour',
    '1_to_2_hours': '1 to 2 hours',
  },
  type: {
    lesson: 'Lesson',
    course: 'Course',
    collection: 'Collection',
    team_training: 'Team training',
    learning_path: 'Learning path',
    certification: 'Certification',
  },
  learningLevel: {
    beginner: 'Beginner',
    advanced: 'Advanced',
    intermediate: 'Intermediate',
  },
  product: {
    trello: 'Trello',
    'jira-product-discovery': 'Jira Product Discovery',
    confluence: 'Confluence',
    bitbucket: 'Bitbucket',
    loom: 'Loom',
    'jira-service-management': 'Jira Service Management',
    compass: 'Compass',
    forge: 'Forge',
    'jira-align': 'Jira Align',
    'atlassian-guard': 'Guard',
    'jira-core': 'Jira',
    rovo: 'Rovo',
  },
  productRole: {
    trello_workspace_admin: 'Trello Workspace Admin',
    jira_board_admin: 'Jira Board Admin',
    jira_admin: 'Jira Admin',
    atlassian_cloud_organization_admin: 'Atlassian Cloud Organization Admin',
    confluence_site_admin: 'Confluence Site Admin',
    jira_service_management_project_admin: 'Jira Service Management Project Admin',
    jira_project_admin: 'Jira Project Admin',
    trello_board_admin: 'Trello Board Admin',
    confluence_space_admin: 'Confluence Space Admin',
  },
  deployment: {
    cloud: 'Cloud',
    data_center: 'Data Center',
  },
};

const mapAtlenzResourceCount = (atlenzResourceCounts: Omit<AtlenzCountersResponse, 'total'>): TaxonomyCount => {
  const totalCounts: TaxonomyCount = {};

  for (const [filterGroupKey, filterGroup] of Object.entries(AtlenzTaxonomyMap)) {
    totalCounts[filterGroupKey] = {};
    for (const [atlenzFilterKey, contentfulValue] of Object.entries(filterGroup)) {
      const typedGroupKey = AtlenzFilterType[filterGroupKey as keyof typeof AtlenzFilterType];

      totalCounts[filterGroupKey][contentfulValue] = atlenzResourceCounts[typedGroupKey]?.[atlenzFilterKey] ?? 0;
    }
  }

  return totalCounts;
};

export const countAllAtlenzResources = async (
  filters: Record<string, string[]>,
  search: string = '',
): Promise<ResourceCount> => {
  const { total = 0, ...atlenzResourceCounts } =
    ((await getAtlenzCatalogResourcesCount(filters, search)) as AtlenzCountersResponse) || {};

  return {
    taxonomyCount: mapAtlenzResourceCount(atlenzResourceCounts || {}),
    totalResources: total,
  };
};
